import { render, staticRenderFns } from "./sales-dashboard.vue?vue&type=template&id=6294eb94"
import script from "./sales-dashboard.vue?vue&type=script&lang=js"
export * from "./sales-dashboard.vue?vue&type=script&lang=js"
import style0 from "./sales-dashboard.vue?vue&type=style&index=0&id=6294eb94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports